import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { LayoutGrid, FilePlus2, GraduationCap, BookOpen, Home, Compass, PlayCircle } from 'lucide-react'

// Thanh điều hướng dashboard soạn bài (kiểu e-learning).
const items = [
  { to: '/teacher/khoa-hoc', label: 'Khoá học của tôi', icon: BookOpen, exact: true },
  { to: '/teacher/elearning', label: 'Bài giảng của tôi', icon: LayoutGrid, exact: true },
  { to: '/soan-bai', label: 'Tạo bài giảng mới', icon: FilePlus2, exact: false },
  { to: '/khoa-hoc', label: 'Khám phá khoá học', icon: Compass, exact: true },
  { to: '/dang-hoc', label: 'Đang học', icon: PlayCircle, exact: true },
]

const DashboardSidebar: React.FC = () => {
  const { pathname } = useLocation()
  return (
    <aside className="w-60 shrink-0 bg-white border-r border-gray-100 min-h-screen p-4">
      <Link to="/" className="flex items-center gap-2 mb-4 px-2 group" title="Về trang chủ">
        <span className="w-9 h-9 rounded-xl bg-blue-600 text-white flex items-center justify-center">
          <GraduationCap size={20} />
        </span>
        <div className="leading-tight">
          <p className="text-sm font-black text-gray-900 group-hover:text-blue-700">Soạn bài giảng</p>
          <p className="text-[11px] text-gray-400">E-learning Studio</p>
        </div>
      </Link>
      {/* Về trang chủ */}
      <Link
        to="/"
        className="flex items-center gap-3 px-3 py-2.5 mb-2 rounded-xl text-sm font-semibold text-gray-600 hover:bg-gray-50 border border-gray-100"
      >
        <Home size={18} /> Về trang chủ
      </Link>
      <nav className="space-y-1">
        {items.map((it) => {
          const Icon = it.icon
          const active = it.exact ? pathname === it.to : pathname.startsWith(it.to)
          return (
            <Link
              key={it.to}
              to={it.to}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold transition-colors ${
                active ? 'bg-blue-50 text-blue-700' : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <Icon size={18} /> {it.label}
            </Link>
          )
        })}
      </nav>
    </aside>
  )
}

export default DashboardSidebar
